import React from 'react';
import createReactClass from 'create-react-class';
import Reflux from 'reflux';
import find from 'lodash/find';

import actions from '../actions';

import configurationStore from '../stores/configuration-store';
import tabStateStore from '../stores/tab-state-store';
import itemCountStore from '../stores/item-count-store';
import accessoryCountStore from '../stores/accessory-count-store';
import itemStore from '../stores/item-store';
import accessoryStore from '../stores/accessory-store';
import sheetStore from '../stores/sheet-store';
import facetPreselectionStore from '../stores/item-preselection-facet-store';

import ModelWizard from './wizard-model';
import ItemWizard from './wizard-item';
import AccessoryWizard from './wizard-accessory';
import SheetButton from './sheet-button';
import Result from './result';
import Sheet from './sheet';
import Menu from './menu';

import events from '../../../events';
import getWindowSize from '../../../utils/window-size';

import {ANIMATION_DURATION} from '../constants';

const l = configurationStore.getLocalization.bind(configurationStore);
const CLASS_NAME = 'slx-product-wizard-wrapper';

const pageIds = ['assistant', 'resultsItem', 'resultsAccessory'];

export default createReactClass({
	displayName: 'ProductWizardWrapper',
	menuToActive: null,
	currentPage: 'assistant',

	mixins: [
		Reflux.listenTo(configurationStore, 'onConfigurationChange'),
		// Reflux.listenTo(tabStateStore, 'onTabChange'),
		Reflux.listenTo(itemCountStore, 'onItemCountChange'),
		Reflux.listenTo(accessoryCountStore, 'onAccessoryCountChange'),
		Reflux.listenTo(itemStore, 'onItemChange'),
		Reflux.listenTo(accessoryStore, 'onAccessoryChange'),
		Reflux.listenTo(sheetStore, 'onSheet'),
		Reflux.listenTo(facetPreselectionStore, 'onItemPreselectionCountChange'),
		Reflux.listenTo(actions.nextItemListPage, 'onNextItemListPage'),
		Reflux.listenTo(actions.nextAccessoryListPage, 'onNextAccessoryListPage'),
		Reflux.listenTo(actions.loadItemsDone, 'onLoadItemsDone'),
		Reflux.listenTo(actions.loadAccessoriesDone, 'onLoadAccessoriesDone'),
		Reflux.listenTo(actions.wizLoading, 'onLoading'),
		Reflux.listenTo(actions.wizLoadingDone, 'onLoadingDone'),
		Reflux.listenTo(actions.selectPropertyById, 'onSelectPropertyById')
	],

	getInitialState() {
		return {
			tabs: tabStateStore.getInitialState(),
			itemCount: 0,
			accessoryCount: 0,
			items: [],
			accessories: [],
			selected: false,
			stickButton: null,
			sheet: null,
			isSheetAuto: false,
			itemResultsCompositions: [],
			accessoryResultsCompositions: [],
			languageCode: configurationStore.getLanguageCode(),
			region: configurationStore.getRegion(),
			apiUrl: configurationStore.getApiUrl(),
			showDisabled: configurationStore.getShowDisabled(),
			isLoading: false,
			isResultItemLoading: false,
			isResultAccessoryLoading: false,
			menuActive: 'assistant',
			pagerStatus: null
		};
	},

	componentDidMount() {
		events.on('resize', this.onResize);
		events.emit('resize', getWindowSize());
		events.on('scroll', this.onScroll);
	},

	componentWillUnmount() {
		events.removeListener('resize', this.onResize);
	},

	onResize(size) {
		if (!this.refs.refSizer) {
			return;
		}
		const refWidth = this.refs.refSizer.offsetWidth;
		actions.windowResize(size.width, refWidth);
	},

	onScroll() {
		this.checkButton();
	},

	onConfigurationChange(data) {
		this.setState({
			itemResultsCompositions: data.compositions || [],
			accessoryResultsCompositions: data.accessories.compositions || [],
			languageCode: data.languageCode,
			region: data.region,
			apiUrl: data.apiUrl
		});
	},

	onItemCountChange(data) {
		this.setState({itemCount: data.count || 0});
	},

	onAccessoryCountChange(data) {
		this.setState({accessoryCount: data.count || 0});
	},

	onItemChange(data) {
		if (this.state.items.length <= 0 && data.items.length > 0 && this.menuToActive === 'resultsItem') {
			this.changePage('resultsItem', () => {
				this.setState({menuActive: this.menuToActive});
				this.menuToActive = null;
				actions.resetAccessoryListPage();
			});
		}

		this.setState({items: data.items});
	},

	onAccessoryChange(data) {
		if (this.state.accessories.length <= 0 && data.items.length > 0 && this.menuToActive === 'resultsAccessory') {
			this.changePage('resultsAccessory', () => {
				this.setState({menuActive: this.menuToActive});
				this.menuToActive = null;
				actions.resetItemListPage();
			});
		}
		this.setState({accessories: data.items});
	},

	onTabChange(state) {
		this.setState({tabs: state});
		this.setState({selected: this.state.tabs.selected.length > 0});
		this.checkButton();
	},

	onSheet(state) {
		if (state.item !== this.state.sheet) {
			this.setState({
				sheet: state.item,
				isSheetAuto: state.isAuto
			});
		}
	},

	onItemPreselectionCountChange(data) {
		if (!data.isSelected) {
			this.setState({
				items: [],
				accessories: [],
				itemCount: 0,
				accessoryCount: 0
			});
		} else if (tabStateStore.getState().selected.indexOf('accessory') < 0) {
			actions.selectTab('item');
		}
	},

	onNextItemListPage() {
		this.setState({isResultItemLoading: true});
	},

	onNextAccessoryListPage() {
		this.setState({isResultAccessoryLoading: true});
	},

	onLoadItemsDone() {
		this.setState({isResultItemLoading: false});
		actions.wizLoadingDone();
	},

	onLoadAccessoriesDone() {
		this.setState({isResultAccessoryLoading: false});
		actions.wizLoadingDone();
	},

	checkButton() {
		let stick = null;
		if (this.state.selected && this.state.itemCount > 0) {
			if (this.refs.container.getBoundingClientRect().bottom > getWindowSize().height) {
				if (this.refs.container.getBoundingClientRect().top > getWindowSize().height - this.refs.button.offsetHeight) {
					stick = 'top';
				} else {
					stick = 'bottom';
				}
			}
		}
		this.setState({stickButton: stick});
	},

	downloadFamilySheet() {
		alert('TODO'); // eslint-disable-line no-alert
	},

	onClickMenu(id) {
		this.menuToActive = id;
		if (id === 'resultsItem') {
			actions.nextItemListPage();
		} else if (id === 'resultsAccessory') {
			actions.nextAccessoryListPage();
		} else if (id === 'assistant') {
			this.changePage('assistant', () => {
				this.setState({menuActive: id});
				actions.resetItemListPage();
				actions.resetAccessoryListPage();
			});
		}
	},

	changePage(page, callback) {
		let way = pageIds.indexOf(page) < pageIds.indexOf(this.currentPage) ? 'left' : 'right';
		this.setState({pagerStatus: ` hide ${way}`});
		setTimeout(() => {
			this.setState({pagerStatus: ` show ${way}`});
			this.currentPage = page;
			callback();
			events.emit('resize', getWindowSize());
			setTimeout(() => {
				this.setState({pagerStatus: null});
			}, ANIMATION_DURATION);
		}, ANIMATION_DURATION);
	},

	onLoading() {
		if (!this.state.isLoading) {
			this.setState({isLoading: true});
		}
	},

	onLoadingDone() {
		if (this.state.isLoading) {
			this.setState({isLoading: false});
		}
	},

	// back to assistent in external property change
	onSelectPropertyById(facetId, propertyId) {
		if (this.currentPage !== 'assistant') {
			this.changePage('assistant', () => {
				this.setState({menuActive: 'assistant'});
				actions.resetItemListPage();
				actions.resetAccessoryListPage();
			});
		}
	},

	render() {
		let className = CLASS_NAME;
		const isActive = this.state.itemCount > 0;
		if (isActive) {
			className += ' active';
		}
		if (this.state.isLoading) {
			className += ' loading';
		}

		let pagerClassName = `${CLASS_NAME}__pager`;
		if (this.state.pagerStatus) {
			pagerClassName += this.state.pagerStatus;
		}

		let assistantBlock = <span />;
		let resultsItemBlock = <span />;
		let resultsAccessoryBlock = <span />;


		if (this.state.menuActive === 'assistant') {
			assistantBlock = (
				<div className={`${CLASS_NAME}__container`} ref="container">
					<div className={`${CLASS_NAME}__accordeon`}>
						<ModelWizard />
						<ItemWizard
							itemCount={this.state.itemCount}
						/>
						<AccessoryWizard
							itemCount={this.state.accessoryCount}
						/>
						<div className={`${CLASS_NAME}__sizer-wrap`}>
							<div className={`${CLASS_NAME}__sizer`} ref="refSizer"></div>
						</div>
						<div className={`${CLASS_NAME}__border`}></div>
					</div>
					<SheetButton
						visible={this.state.region === 'usa' || this.state.region === 'can'}
						inactive={!isActive}
						stick={this.state.stickButton}
						itemCount={this.state.itemCount}
						accessoryCount={this.state.accessoryCount}
					/>
				</div>
			);
		} else if (this.state.menuActive === 'resultsItem') {
			resultsItemBlock = (
				<Result
					id="result-item"
					title={l('resultsItemTitle')}
					count={this.state.itemCount}
					items={this.state.items}
					actionNextPage={actions.nextItemListPage}
					actionResetPage={actions.resetItemListPage}
					compositions={this.state.itemResultsCompositions}
					isLoading={this.state.isResultItemLoading}
				/>
			);
		} else if (this.state.menuActive === 'resultsAccessory') {
			resultsAccessoryBlock = (
				<Result
					id="result-accessory"
					title={l('resultsAccessoryTitle')}
					count={this.state.accessoryCount}
					items={this.state.accessories}
					actionNextPage={actions.nextAccessoryListPage}
					actionResetPage={actions.resetAccessoryListPage}
					compositions={this.state.accessoryResultsCompositions}
					isLoading={this.state.isResultAccessoryLoading}
				/>
			);
		}

		return (
			<div className={className}>
				<Menu
					onSelectProperty={this.onClickMenu}
					itemCount={this.state.itemCount}
					accessoryCount={this.state.accessoryCount}
					selected={this.state.menuActive}
					region={this.state.region}
				/>
				<div className={pagerClassName}>
					{assistantBlock}
					{resultsItemBlock}
					{resultsAccessoryBlock}
				</div>
				<Sheet item={this.state.sheet} isAuto={this.state.isSheetAuto} languageCode={this.state.languageCode} region={this.state.region} apiUrl={this.state.apiUrl}/>
			</div>
		);
	}
});
